/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { GetValueDeterminationsResponseJson } from './get-value-determinations-response-json';
import { GetValueDeterminationsResult } from '../results/get-value-determinations-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { ValueDeterminationDto } from '../models/value-determination-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class GetValueDeterminationsResponse extends ResponseWithErrorGeneric<GetValueDeterminationsResponseJson, GetValueDeterminationsResult> implements IResponseWithErrorGeneric<GetValueDeterminationsResult> {
  public valueDeterminations: ValueDeterminationDto[];

  //<custom-body>
  constructor(response: HttpResponse<GetValueDeterminationsResponse>) {
    super(response, GetValueDeterminationsResult.Error);
    if (this.result !== GetValueDeterminationsResult.Success) {
      return;
    }

    this.valueDeterminations = this.body.valueDeterminations;
  }
  //</custom-body>
}
